export interface ApiException {
  errorMessage: string;
  status: number;
}

export interface ApiResponse {
  data?: { message: string };
  status: number;
  statusText: string;
}

export const exceptionFromResponse = (response: ApiResponse): ApiException => ({
  errorMessage: response.data?.message
    ? response.data?.message
    : response.statusText,
  status: response.status,
});

export const genericError = (attemptedAction: string): string =>
  `Sorry, we were unable to ${attemptedAction}.  Please try again or call 13 73 35 or assistance.`;
